import get from 'lodash/get';
import { RestConfig, getHostConfig } from '../Common/RestConfig';

/**
 * Function to return orchestration config
 * based on action object
 * @param {Object} obj : Takes action object
 * @returns {Object}  configObject : update config object
 */
export const getOrchestrationConfig = (obj) => {
    let config = RestConfig.v1OrchestrationConfig();
    config = getHostConfig(config);
    config.accessToken = get(obj, 'accessToken');
    return config;
};

export default {
    getOrchestrationConfig,
};
